import React, { useEffect, useState } from 'react';
import { Box, Heading, Text, Flex, Button, Spinner, Alert, AlertIcon } from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';
import BloodDrawForm from '../../BloodDrawForm';

// /lab-portal/new-draw — gated by the same labSession that LabPortalDashboard uses.
// Pins the new submission to the logged-in lab via BloodDrawForm's forcedLabId prop.

export default function LabNewDraw() {
  const navigate = useNavigate();
  const [labSession, setLabSession] = useState(null);
  const [status, setStatus] = useState('loading');

  useEffect(() => {
    try {
      const raw = localStorage.getItem('labSession');
      if (!raw) { setStatus('no-session'); return; }
      const parsed = JSON.parse(raw);
      if (!parsed?.id) { setStatus('no-session'); return; }
      setLabSession(parsed);
      setStatus('ready');
    } catch (_) {
      setStatus('no-session');
    }
  }, []);

  if (status === 'loading') {
    return <Flex h="60vh" align="center" justify="center"><Spinner /></Flex>;
  }
  if (status === 'no-session') {
    return (
      <Box maxW="md" mx="auto" mt={10} p={6} bg="white" borderRadius="md" boxShadow="md">
        <Alert status="error" mb={4}><AlertIcon />You're not signed in to a lab portal.</Alert>
        <Button colorScheme="blue" onClick={() => navigate('/lab-portal/login')}>Go to Lab Login</Button>
      </Box>
    );
  }

  return (
    <Box>
      <Flex bg="white" borderBottomWidth="1px" px={6} py={3} align="center" justify="space-between">
        <Box>
          <Heading size="md">New Blood Draw</Heading>
          <Text fontSize="sm" color="gray.500">Filing for {labSession.name}</Text>
        </Box>
        <Button size="sm" variant="ghost" onClick={() => navigate('/lab-portal/dashboard')}>
          Back to Dashboard
        </Button>
      </Flex>
      <BloodDrawForm forcedLabId={labSession.id} hideLabPicker />
    </Box>
  );
}
